<template>
    <div class="order-detail" v-if="actData">
        <div class="order-name">
           <span>报名人信息</span>
           <span>{{OrderMsg.joinName}}</span>
        </div>
        <div class="order-msg">
            <p>活动信息</p>
            <div class="order-content">
                <div class="order-content-l">
                    <img :src="actData.banners[0]"  v-if="actData.banners[0]">
                    <img src="@assets/img/empty.png"  v-else>
                </div>
                <div class="order-content-r">
                    <h2>{{actData.title}}</h2>
                    <p class="time">
                        {{actData.startTime | moment('MM/DD HH:mm')}} ~ {{actData.endTime | moment('MM/DD HH:mm')}}
                    </p>
                    <p class="comp" v-if="actData.company">{{actData.company.name}}</p>
                </div>
            </div>
        </div>
        <div class="order-price">
            <p>购票</p>
            <p><span>{{OrderMsg.title}}<em>x{{OrderMsg.num}}</em></span> <span><i>￥</i>{{OrderMsg.totalPrice}}</span></p>
        </div>
        <div class="order-footer">
            <div class="order-totol">
                <span>合计：<i>￥</i></span>{{OrderMsg.totalPrice}}
            </div>
            <div class="order-btn" @click="WxPay()">支付</div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import gql from 'graphql-tag';
export default {
    data(){
        return{
           actData:'',
           orderInfo:'',
        }
    },
    computed:{
        ...mapGetters({
            OrderMsg:'wxPay/getOrder',
            user: "getUserInfo",
        }),
        actId(){ return  this.$route.params.id },
        ActDetailsGql(){ // 查询活动详情
            return gql`query activity($id: Guid!){
                    activity(id: $id){
                        banners
                        company{
                            name
                            id
                            logo
                        }
                        endTime
                        exhibitionId
                        exhibitorId
                        followCount
                        id
                        startTime
                        title
                        userCount
                        likeCount
                        viewCount
                    }
                }`
            },
    },
    created() {
        this.init();
    },
    methods:{
        ...mapActions({
            getActDetail:'act/getActDetail',
            addOrder:'act/addOrder',
            wechatPay:'wxPay/wechatPay',
            payFor:'wxPay/payFor',
            LinkToActFinish:"linkTo/LinkToActFinish",
        }),
        async init(){
            this.getActDetails();
            await this.$Myapollo.getUserInfo(this);
        },
        async getActDetails(){
            this.$apollo.addSmartQuery('activity', {
                query:this.ActDetailsGql, 
                variables: {
                    id:this.actId
                },
                fetchPolicy: "no-cache", //清理缓存
                result(res) {
                    if(res.data.activity){
                        this.actData = res.data.activity;
                        if(this.actData.banners.indexOf('[') != -1){
                            this.actData.banners = JSON.parse(this.actData.banners);
                        } else {
                            this.actData.banners = [this.actData.banners]
                        }
                        this.$store.commit("setExhibitionId",this.actData.exhibitionId);
                    } 
                },// 错误处理
                error(error) {
                    console.error(error,'error错误处理')
                }
            })
        },
        WxPay(){
            this.createdOrder();
        },
        // 创建订单
        async createdOrder(){
            let tickets = [{
                Title:this.OrderMsg.title,
                // Price:this.OrderMsg.totalPrice / this.OrderMsg.num,
                Number:this.OrderMsg.num,
            }]
            let body = {
                exhibitionId:this.actData.exhibitionId,
                activityId: this.actId,
                activityRegId:this.OrderMsg.regId,
                memberId: this.user.id,
                userId: this.user.userId,
                tickets: JSON.stringify(tickets),
                amount: this.OrderMsg.totalPrice * 100,
            };
            let res =  await this.addOrder(body);
            if(res.result && res.data) {
                this.orderInfo = res.data;
                this.payOrder();
            } else {
                this.$toast.fail(res.message);
            }
        },
        async payOrder(){
            let opt = {
                businessType: 'activity.buy.ticket',
                businessId: this.orderInfo.id,
                userId: this.user.userId,
                inMemberId: this.user.inMember.id,
                amount: this.orderInfo.amount,
                subject: '活动购票',
                body: '活动购票',
                tradeType: 'JSAPI'
            }
            let res =  await this.wechatPay(opt);
            console.log(res,'---');
            if(res.parameter){ // 微信支付订单创建成功
               this.payFor(res).then(data => {
                    if (data) {
                        // 支付成功
                        this.LinkToActFinish(this.actId);
                    } else {
                        this.$toast.fail('支付失败');
                    }
                });
            }
        },

    },
    
}
</script>
<style lang="scss" scoped>
.order{
    &-detail{
        height: 100vh;
        background: #f2f2f2;
    }
    &-name{
       width: 100%;
       padding:.36rem .3rem ;
       background: #fff;
       display: flex;
       align-items: center;
       justify-content: space-between;
       color: #333;
       font-size: .26rem;
       margin-bottom: .2rem;
       span:last-child{
           font-size: .3rem;
           font-weight: 600;
       }
    }
    &-msg{
        width: 100%;
        padding:.3rem ;
        background: #fff;
        color: #333;
        font-size: .26rem;
        margin-bottom: .2rem;
        p{
            font-size: inherit;
        }
    }
    &-content{
        margin-top: .24rem;
        display: flex;
        align-items: center;
        &-l{
            width: 2.2rem;
            height: 1.23rem;
            margin-right: .2rem;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-r{
            width: calc(100% - 2.4rem);
            h2{
                font-size: .26rem;
                color: #222;
                font-weight: 600;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 1.6;
            }
            .time{
                font-size: .2rem;
                color: #666;
                line-height: 1.8;
            }
            .comp{
                font-size: .22rem;
                color: #666;
                line-height: 1.6;
            }
        }
    }
    &-price{
        width: 100%;
        padding:.3rem ;
        background: #fff;
        color: #333;
        font-size: .26rem;
        margin-bottom: .2rem;
        p,span{
            font-size: inherit;
        }
        p:last-child{
            margin-top: .2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span:first-child{
                em{
                    font-style: normal;
                    font-size: inherit;
                    margin-left: .28rem;
                }
            }
            span:last-child{
                color: #ff5e00;
                font-size: .3rem;
                font-weight: 600;
                i{
                    font-style: normal;
                    font-size: .24rem;
                    font-weight: normal;
                }
            }
        }
    }
    &-footer{
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: .94rem;
        padding: 0 .3rem;
        background: #fff;
        border-top: 1px solid #e6e6e6;
    }
    &-totol{
        color: #ff5e00;
        font-size: .3rem;
        font-weight: 600;
        i{
            font-style: normal;
            font-size: .24rem;
            font-weight: normal;
            color: #ff5e00;
        }
        span{
            color: #333;
            font-weight: normal;
        }
    }
    &-btn{
        width: 2.6rem;
        height: .74rem;
        background-color: #1890ff;
	    border-radius: .37rem;
        text-align: center;
        line-height: .74rem;
        color: #fff;
        font-size: .3rem;
        font-weight: 600;
    }
}

</style>